export default __webpack_public_path__ + "static/media/C_Cenoura.04e7e246.mp3";